module.exports = __webpack_public_path__ + "img/知乎.7df78c8b.svg";